import type * as React from "react";
import { icons } from "./icon-data.js";
import type { IconName } from "./icon-data.js";

export type { IconName };

export interface IconProps extends React.SVGProps<SVGSVGElement> {
  name: IconName;
  size?: number | string;
}

/**
 * Wanted Design System icon (151 single-color glyphs). Recolor with CSS `color`.
 * Decorative by default: pass `aria-label` (and `aria-hidden={false}`) when the icon carries
 * meaning on its own.
 */
export function Icon({ name, size, ...rest }: IconProps) {
  const d = icons[name];
  if (!d) return null;
  return (
    <svg
      width={size}
      height={size}
      viewBox={d.viewBox}
      fill="none"
      aria-hidden
      focusable="false"
      // Body strings are emitter-controlled <path> markup shipped by the design system bundle
      // (geometry and numeric fills only, no user input), rendered the same way upstream does.
      // biome-ignore lint/security/noDangerouslySetInnerHtml: trusted DS glyph data, see above
      dangerouslySetInnerHTML={{ __html: d.body }}
      {...rest}
    />
  );
}

export default Icon;
